<template>
    <v-container>
        <v-alert
            border="left"
            color="rgb(202, 51, 51)"
            type="info"
        >
            {{ $t('notice') }}
        </v-alert>
        <v-alert
            border="left"
            color="rgb(52, 152, 24)"
            type="success"
            v-if="registrationNotice"
        >
            {{registrationNotice}}
        </v-alert>
        <v-row>
            <v-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" :key="competition.id" v-for="competition in filteredCompetitions" v-if="competition.visible || $page.user !== null">
                <v-card class="my-3 flex-grow-1 d-flex flex-column">
                    <v-sheet color="black" dark height="128px">
                        <v-card-title class="competition-title white-text">
                            <span>{{ competition.name }}</span>
                            <template v-if="$page.user !== null">
                                <v-spacer></v-spacer>
                                <v-icon v-if="competition.visible" style="color: white">mdi-eye</v-icon>
                                <v-icon v-else style="color: white">mdi-eye-off</v-icon>
                            </template>
                        </v-card-title>
                    </v-sheet>
                    <v-card-subtitle class="d-flex flex-column">
                        <span>Data zawodów: {{ competition.date }}</span><br>
                        <span v-if="$page.user">Data aktywacji: {{ competition.activation_date }}</span>
                        <img :src="getLeagueImage(competition)" v-if="getLeagueImage(competition)" alt="League img" class="league-img">
                    </v-card-subtitle>
                    <v-card-actions class="mt-auto">
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-space-between">
                                <v-btn @click="showDetails(competition)" text>
                                    {{$t('details')}}
                                </v-btn>
                                <v-btn v-if="shouldShowList(competition)" @click="showStartList(competition)" text>
                                    {{$t('startList')}}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" class="d-flex justify-space-between">
                                <v-btn v-if="$page.user !== null" @click="showEditDialog(competition)" text>
                                    Edytuj
                                </v-btn>
                                <v-btn v-if="$page.user !== null" @click="duplicateCompetition(competition)" text>
                                    Duplikuj
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <div v-if="$page.user !== null" @click="showCreateDialog" class="create-competition ma-3">+</div>
        </v-row>
        <v-dialog :key="componentKey" max-width="550" persistent v-model="competitionDialog">
            <v-card>
                <v-card-title>Podaj informacje zawodów</v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-text-field :rules="requiredRule" label="Nazwa zawodów" prepend-icon="mdi-card-text-outline"
                                      v-model="competition.name"></v-text-field>
                        <v-menu :rules="requiredRule" :close-on-content-click="false"
                                :return-value.sync="competition.date" min-width="290px" offset-y ref="menu1"
                                transition="scale-transition" v-model="datepickerMenu1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field label="Data zawodów" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                              v-model="competition.date" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker scrollable v-model="competition.date">
                                <v-spacer></v-spacer>
                                <v-btn @click="datepickerMenu21 = false" color="primary" text>Anuluj</v-btn>
                                <v-btn @click="$refs.menu1.save(competition.date)" color="primary" text>OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-menu
                            ref="menu4"
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="competition.time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="competition.time"
                                    label="Godzina zawodów"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="menu4"
                                format="24hr"
                                v-model="competition.time"
                                full-width
                                @click:minute="$refs.menu4.save(competition.time)"
                            ></v-time-picker>
                        </v-menu>
                        <v-text-field :rules="numberRule" label="Limit wyboru treningów" prepend-icon="mdi-block-helper"
                                      v-model="competition.selection_limit"></v-text-field>
                        <v-menu :rules="requiredRule" :close-on-content-click="false"
                                :return-value.sync="competition.activation_date" min-width="290px" offset-y ref="menu2"
                                transition="scale-transition" v-model="datepickerMenu2">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field label="Data aktywacji zawodów" prepend-icon="mdi-calendar" readonly
                                              v-bind="attrs" v-model="competition.activation_date"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker scrollable v-model="competition.activation_date">
                                <v-spacer></v-spacer>
                                <v-btn @click="datepickerMenu2 = false" color="primary" text>Anuluj</v-btn>
                                <v-btn @click="$refs.menu2.save(competition.activation_date)" color="primary" text>OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-menu
                            ref="menu3"
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="competition.activation_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="competition.activation_time"
                                    label="Godzina aktywacji zawodów"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="menu3"
                                format="24hr"
                                v-model="competition.activation_time"
                                full-width
                                @click:minute="$refs.menu3.save(competition.activation_time)"
                            ></v-time-picker>
                        </v-menu>
                        <v-select prepend-icon="mdi-flag-checkered" label="Liga zawodów" :items="leagues" v-model="competition.league" item-text="name" item-value="value"/>
                        <v-checkbox class="mt-0" label="Widoczne na liście" v-model="competition.visible"></v-checkbox>
                        <div class="d-flex mb-2">
                            <span class="text-h5">Przejazdy</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="addTraining" color="blue" dark>Dodaj</v-btn>
                        </div>
                        <v-row class="my-2" :key="index" no-gutters v-for="(training, index) in competition.trainings">
                            <v-col cols="6" md="3" class="">
                                <v-text-field hide-details label="Tytuł" v-model="training.name"></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" class="">
                                <v-text-field hide-details label="Start" type="time" v-model="training.start_time"
                                              value="10:30"></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" class="">
                                <v-text-field hide-details label="Koniec" type="time" v-model="training.end_time"
                                              value="10:30"></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2" class="">
                                <v-text-field hide-details label="L.miejsc" type="number"
                                              v-model="training.seats_number"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" class="d-flex align-end">
                                <v-btn v-if="editActive" @click="showDeleteTrainingDialog(training)" class="my-2"
                                       color="red" :text="!isMobile" :block="isMobile" :outlined="isMobile">
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                                <v-btn cols="12" md="1" v-if="!editActive"
                                       @click="competition.trainings.splice(index,1)" color="red" :text="!isMobile"
                                       :block="isMobile" :outlined="isMobile">
                                    <v-icon class="delete-rotated">
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row no-gutters class="justify-content-between">
                            <v-col class="my-1" cols="12">
                                <v-btn block outlined v-if="!editActive" color="blue" @click="saveCompetition">Dodaj
                                    zawody
                                </v-btn>
                                <v-btn block outlined v-if="editActive" color="blue" @click="updateCompetition">Edytuj
                                    zawody
                                </v-btn>
                            </v-col>
                            <v-col class="my-1" cols="12">
                                <v-btn v-if="editActive" color="red" @click="deleteCompetitionDialog=true" block outlined>Usuń
                                    zawody
                                </v-btn>
                            </v-col>
                            <v-col class="my-1" cols="12">
                                <v-btn @click="competitionDialog = false" block outlined>Anuluj</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="competitionDetailsDialog">
            <v-card>
                <v-toolbar color="black" dark>
                    <v-btn @click="competitionDetailsDialog = false" dark icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
                </v-toolbar>
                <v-container>
                    <v-row>
                        <v-col :key="training.id" cols="12" md="3" v-for="training in selectedCompetition.trainings">
                            <v-card>
                                <v-card-title class="black white-text">
                                    {{ training.name }} | {{ training.start_time }} - {{ training.end_time }} |
                                    {{ training.drivers.length || "0" }} /
                                    {{ training.seats_number }}
                                </v-card-title>
                                <v-card-text class="pa-0">
                                    <v-list class="py-0">
                                        <template v-for="(driver, index) in training.drivers">
                                            <v-list-item :key="driver.id">
                                                {{ index + 1 }}. {{ driver.name }}
                                                <v-spacer></v-spacer>
                                                <!--                                                <b v-if="$page.user !== null" class="mr-3">{{ driver.voucher }}</b>-->
                                                <!--                                                <v-btn v-if="$page.user !== null && driver.verified === 0" @click="verifyDriver(driver)" icon color="green">-->
                                                <!--                                                    <v-icon>-->
                                                <!--                                                        mdi-check-->
                                                <!--                                                    </v-icon>-->
                                                <!--                                                </v-btn>-->
                                                <v-btn v-if="$page.user !== null" @click="showDeleteDialog(driver)" icon
                                                       color="red">
                                                    <v-icon>
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn v-if="$page.user !== null" @click="showEditDriverDialog(driver)" icon
                                                       color="blue">
                                                    <v-icon>
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                        </template>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions v-if="$page.user !== null">
                                    <v-btn  block text @click="showAddDriverDialog(training)">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog max-width="350px" v-model="deleteDialog">
            <v-card>
                <v-card-title class="break-word">
                    Czy na pewno chcesz usunąć kierowcę?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteDialog = false" text>Anuluj</v-btn>
                    <v-btn text @click="deleteDriver" color="red">Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="350px" v-model="editDriverDialog">
            <v-card>
                <v-card-title class="break-word">
                    Edytuj dane kierowcy
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="selectedDriver.name" placeholder="Imię i nazwisko"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="editDriverDialog = false" text>Anuluj</v-btn>
                    <v-btn text @click="editDriver" color="blue">Edytuj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="350px" v-model="addDriverDialog">
            <v-card>
                <v-card-title class="break-word">
                    Wprowadź dane kierowcy
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="newDriver.name" placeholder="Imię i nazwisko"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="addDriverDialog = false" text>Anuluj</v-btn>
                    <v-btn text @click="addDriver" color="green" :disabled="!newDriver.name">Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="350px" v-model="deleteTrainingDialog">
            <v-card>
                <v-card-title class="break-word">
                    Czy na pewno chcesz usunąć przejazd?
                </v-card-title>
                <v-card-text>
                    Usunięcie przejadzu spowoduje nieodwracalne usunięcie kierowców biorących udział w tym przejeździe.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteTrainingDialog = false" text>Anuluj</v-btn>
                    <v-btn text @click="deleteTraining" color="red">Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="350px" v-model="startListDialog">
            <v-card>
                <v-card-title class="break-word">
                    Lista startowa zawodów
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item class="py-0 my-0" :key="index" v-for="(driver, index) in selectedCompetitionDrivers">
                            {{ index + 1 }}. {{ driver }}
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="startListDialog = false" text>Zamknij</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="420px" v-model="deleteCompetitionDialog">
            <v-card>
                <v-card-title class="break-word">
                    Czy na pewno chcesz usunąć zawody?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteCompetitionDialog = false" text>Anuluj</v-btn>
                    <v-btn text @click="deleteCompetition" color="red">Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbarBool">
            {{ snackbarMessage }}
            <template #action>
                <v-btn @click="snackbarBool=false" text>OK</v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
    name: "Index",
    props: ['competitions'],
    // created() {
    //     this.competitions.forEach((c, i) => {
    //         c.drivers = this.groupBy(c.drivers, 'driver_code')
    //     })
    // },
    data() {
        return {
            snackbarBool: false,
            snackbarMessage: '',
            registrationNotice: '',
            competitionDialog: false,
            competitionDetailsDialog: false,
            deleteTrainingDialog: false,
            deleteCompetitionDialog: false,
            startListDialog: false,
            deleteDialog: false,
            editActive: false,
            editDriverDialog: false,
            addDriverDialog: false,
            selectedCompetition: '',
            selectedCompetitionDrivers: [],
            selectedDriver: '',
            selectedTraining: '',
            competition: {
                name: '',
                date: '',
                time: '',
                selection_limit: '',
                activation_date: '',
                activation_time: '',
                trainings: [],
                league: null
            },
            newDriver: {
                name: '',
                trainingId: null,
                competitionId: null,
            },
            leagues: [
                {name: "Kielecka", value: 'kielecka'},
                {name: "Poznańska", value: 'poznanska'},
                {name: "Śląska", value: 'slaska'},
                {name: "Pomorska", value: 'pomorska'},
                {name: "PEC", value: 'pec'},
            ],
            datepickerMenu1: false,
            datepickerMenu2: false,
            menu3: false,
            menu4: false,
            componentKey: 0,
            requiredRule: [v => !!v || "Pole jest wymagane"],
            numberRule: [
                v => !!v || "Pole jest wymagane",
                v => !isNaN(v) || "Pole musi być liczbą"
            ],
            startListIndex: 0,
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.name === "xs"
        },
        leagueFilter() {
            return this.getLeagueFilter();
        },
        filteredCompetitions() {
            if (this.leagueFilter) {
                return this.competitions.filter(c => c.league === this.leagueFilter);
            } else {
                return this.competitions;
            }
        }
    },
    inject: ['getLeagueFilter'],
    created() {
        this.competitions.forEach((c, i) => {
            const competitionTimestamp = new Date(c.activation_date).getTime();
            const now = new Date().getTime();
            const filterManualAddedDrivers = competitionTimestamp > now;
            if (filterManualAddedDrivers && this.$page.user === null) {
                c.trainings.forEach(training => {
                    training.drivers = training.drivers.filter(driver => driver.verified === 0);
                })
            }
        })
    },
    mounted() {
        if (this.$page.errors.registration) {
            this.registrationNotice = this.$page.errors.registration;
        }
        if (this.$page.errors.message) {
            this.snackbarMessage = this.$page.errors.message;
            console.error(this.$page.errors.message, this.snackbarMessage);
            this.snackbarBool = true;
        }
    },
    methods: {
        shouldShowList(competition) {
            const competitionTimestamp = new Date(competition.activation_date).getTime();
            const now = new Date().getTime();
            return competitionTimestamp < now;
        },
        groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        addTraining() {
            this.competition.trainings.push({
                'name': '',
                'start_time': '',
                'end_time': '',
                'seats_number': '',
                'drivers': []
            });
        },
        getLeagueImage(competition) {
            switch (competition.league) {
                case "slaska":
                    return "/images/leagues/slaska-light.png"
                case "poznanska":
                    return "/images/leagues/poznanska-light.png"
                case "kielecka":
                    return "/images/leagues/kielecka-light.png"
                case "pomorska":
                    return "/images/leagues/pomorska-light.png"
                case "pec":
                    return "/images/leagues/pec-light.png"
                default:
                    return null;
            }
        },
        showSnackbar(arg) {
            this.snackbarBool = true;
            this.snackbarMessage = arg;
        },
        showDetails(competition) {
            this.selectedCompetition = competition;
            this.competitionDetailsDialog = true;
        },
        showStartList(competition) {
            this.selectedCompetition = competition;
            const drivers = new Set();
            this.selectedCompetition.drivers.forEach(driver => {
                const competitionTimestamp = new Date(competition.activation_date).getTime();
                const now = new Date().getTime();
                const filterManualAddedDrivers = competitionTimestamp > now;
                if (filterManualAddedDrivers && this.$page.user === null && driver.verified === 1) {
                    return
                }
                drivers.add(`${driver.name}`);
            })
            this.selectedCompetitionDrivers = Array.from(drivers);
            this.startListDialog = true;
        },
        showEditDialog(competition) {
            this.competition = {...competition};
            this.competition.time = this.competition.date.split(' ')[1]
            this.competition.date = this.competition.date.split(' ')[0]
            this.competition.activation_time = this.competition.activation_date.split(' ')[1]
            this.competition.activation_date = this.competition.activation_date.split(' ')[0]
            this.editActive = true;
            this.competitionDialog = true;
        },
        saveCompetition() {
            this.$inertia.post('/competitions', this.competition).then(r => {
                this.showSnackbar('Pomyślnie utworzono zawody')
                this.competitionDialog = false;
                this.competition = {};
            });
        },
        updateCompetition() {
            this.$inertia.post('/competitions/update/' + this.competition.id, this.competition).then(r => {
                this.showSnackbar('Pomyślnie edytowano zawody')
                this.competitionDialog = false;
                this.competition = {};
            });
        },
        deleteCompetition() {
            this.$inertia.post('/competitions/destroy/' + this.competition.id, {
                preserveState: true
            }).then(r => {
                this.showSnackbar('Pomyślnie usunięto zawody')
                this.competitionDialog = false;
                this.deleteCompetitionDialog = false;
                this.$inertia.reload();
            });
        },
        duplicateCompetition(competition) {
            this.$inertia.post('/competitions/duplicate', competition).then(r => {
                this.showSnackbar('Pomyślnie zduplikowano zawody')
            });
        },
        showDeleteDialog(driver) {
            this.deleteDialog = true;
            this.selectedDriver = driver;
        },
        editDriver() {
            this.$http.post(`/driver/${this.selectedDriver.id}/updateName`, this.selectedDriver).then(r => {
                this.showSnackbar('Pomyślnie zaktualizowane dane')
                this.selectedCompetition.trainings.forEach(training => {
                    training.drivers.forEach(driver => {
                        if (driver.id === this.selectedDriver.id) {
                            driver.name = r.data.name
                        }
                    })
                })
                this.editDriverDialog = false;
            });
        },
        showEditDriverDialog(driver) {
            this.editDriverDialog = true;
            this.selectedDriver = {...driver};
        },
        showAddDriverDialog(training) {
            this.addDriverDialog = true;
            this.selectedTraining = training;
        },
        addDriver() {
            this.newDriver.trainingId = this.selectedTraining.id;
            this.newDriver.competitionId = this.selectedCompetition.id;
            this.$http.post(`/driver/manualCreate`, this.newDriver).then(response => {
                this.selectedTraining.drivers.push(response.data);
                this.addDriverDialog = false;
                this.showSnackbar('Pomyślnie dodano kierowcę')
            });
        },
        verifyDriver(driver) {
            this.$http.post('api/verifyDriver/' + driver.id).then(response => {
                this.$http.get(`/api/getTrainings?competition=${this.selectedCompetition.id}`).then(response => {
                    this.selectedCompetition.trainings = response.data;
                })
                this.showSnackbar("Pomyślnie zweryfikowano kierowcę");
            })
        },
        showDeleteTrainingDialog(training) {
            this.selectedTraining = training;
            this.deleteTrainingDialog = true
        },
        showCreateDialog() {
            // this.$refs.form.reset();
            this.competitionDialog = true;
            this.editActive = false;
            this.competition = {
                name: '',
                date: '',
                selection_limit: '',
                activation_date: '',
                trainings: []
            }
        },
        deleteDriver() {
            this.$inertia.post('/driver/destroy/' + this.selectedDriver.id, {
                preserveState: true
            }).then(r => {
                this.deleteDialog = false;
                this.$http.get(`/api/getTrainings?competition=${this.selectedCompetition.id}`).then(response => {
                    this.selectedCompetition.trainings = response.data;
                })
                this.showSnackbar('Pomyślnie usunięto kierowcę!')
            })
        },
        deleteTraining() {
            if (!this.selectedTraining.created_at) {
                this.competition.trainings.splice(this.competition.trainings.indexOf(this.selectedTraining), 1);
                this.deleteTrainingDialog = false;
            } else {
                this.$inertia.post('/training/destroy/' + this.selectedTraining.id).then(res => {
                    this.deleteTrainingDialog = false;
                    this.competitionDialog = false
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
